<div class="flex flex-col md:flex-row min-h-screen bg-white">
  <!-- Sidebar para desktop -->
  <app-sidebar
    [circleNumber]="1"
    (backClick)="goBack()"
    class="bg-teu-purple hidden sm:block relative w-full md:w-[197px] h-[120px] md:h-auto flex-shrink-0 overflow-hidden"
  ></app-sidebar>

  <!-- Header para móvil -->
  <app-header [circleNumber]="1" (backClick)="goBack()"></app-header>

  <!-- Main Content -->
  <div class="flex-1 flex flex-col">
    <app-subheader
      [circleNumber]="1"
      [backWindow]="'/'"
      (backClick)="goBack()"
      class="pt-[60px] md:pt-0"
    ></app-subheader>

    <!-- Form Content -->
    <div
      class="flex-1 px-4 md:px-[100px] lg:px-[200px] pb-12 md:pb-20 max-w-[800px] mx-auto w-full"
    >
      <h1 class="teu-title text-2xl md:text-[32px] mb-2 md:mb-4 text-center">
        Bienvenid&#64; a Teu Financiera
      </h1>
      <p class="teu-subtitle text-lg md:text-xl mb-8 md:mb-12 text-center">
        Para empezar tu registro ingresa los siguientes datos
      </p>

      <form
        [formGroup]="registrationForm"
        (ngSubmit)="onSubmit()"
        class="flex flex-col gap-3 max-w-[500px] mx-auto"
      >
        <!-- Número celular -->
        <div class="relative">
          <p-inputMask
            formControlName="phoneNumber"
            mask="(+52) 99 9999 9999"
            [unmask]="true"
            [slotChar]="'_'"
            [autoClear]="false"
            [styleClass]="
              'w-full input-field' +
              (isFieldInvalid('phoneNumber') ? ' ng-invalid ng-dirty' : '')
            "
            placeholder="Teléfono celular"
            inputmode="numeric"
          ></p-inputMask>
          <div
            *ngIf="hasError('phoneNumber')"
            class="text-red-500 text-xs mt-1"
          >
            {{ getErrorMessage("phoneNumber") }}
          </div>
        </div>

        <!-- Confirmar número celular -->
        <div class="relative">
          <p-inputMask
            formControlName="confirmPhoneNumber"
            mask="(+52) 99 9999 9999"
            [unmask]="true"
            [slotChar]="'_'"
            [autoClear]="false"
            [styleClass]="
              'w-full input-field' +
              (isFieldInvalid('confirmPhoneNumber')
                ? ' ng-invalid ng-dirty'
                : '')
            "
            placeholder="Confirmar teléfono celular"
            inputmode="numeric"
          ></p-inputMask>
          <div
            *ngIf="hasError('confirmPhoneNumber')"
            class="text-red-500 text-xs mt-1"
          >
            {{ getErrorMessage("confirmPhoneNumber") }}
          </div>
        </div>

        <!-- Correo electrónico -->
        <div class="relative">
          <input
            type="email"
            formControlName="email"
            placeholder="Correo electrónico"
            class="input-field w-full"
            [class.border-red-500]="hasError('email')"
          />
          <div *ngIf="hasError('email')" class="text-red-500 text-xs mt-1">
            {{ getErrorMessage("email") }}
          </div>
        </div>

        <!-- Código promotor con label 
        <div class="relative">
          <label class="block font-inter text-sm font-normal leading-[140%] text-black mb-2">
            Código promotor TEU
          </label>
          <input
            type="password"
            formControlName="promoCode"
            placeholder="********"
            class="input-field w-full"
            maxlength="8"
            [class.border-red-500]="hasError('promoCode')"
          />
          <div *ngIf="hasError('promoCode')" class="text-red-500 text-xs mt-1">
            {{ getErrorMessage('promoCode') }}
          </div>
        </div>-->

        <div>
          <p-dropdown
            [options]="termsOptions"
            optionLabel="label"
            optionValue="value"
            formControlName="term"
            placeholder="Seleccionar..."
            [class]="
              'w-full md:max-w-[300px]' +
              (term?.invalid && term?.touched ? ' ng-invalid ng-dirty' : '')
            "
          ></p-dropdown>
          <small *ngIf="term?.invalid && term?.touched" class="text-red-500">
            {{ getErrorMessage("term") }}
          </small>
        </div>

        <!-- Sección del monto -->
        <div class="relative">
          <label class="block font-inter text-sm font-normal leading-[140%] text-black mb-2">
            Monto
          </label>
          <input
            type="text"
            formControlName="requestedAmount"
            placeholder="Monto solicitado (ej: $5,000)"
            class="input-field w-full"
            [class.border-red-500]="hasError('requestedAmount')"
            (input)="onAmountInput($event)"
            (blur)="formatCurrency()"
          />
          <div
            *ngIf="hasError('requestedAmount')"
            class="text-red-500 text-xs mt-1"
          >
            {{ getErrorMessage("requestedAmount") }}
          </div>
          
          <!-- Cuadro de detalles del préstamo -->
          <div *ngIf="loadingLoanDetails || loanDetails" class="bg-gray-50 rounded-lg p-4 mt-4 border border-gray-200">
            <h3 class="text-sm font-medium text-gray-900 mb-4">Detalle:</h3>
            
            <!-- Loading state -->
            <div *ngIf="loadingLoanDetails" class="flex items-center justify-center py-4">
              <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
              <span class="ml-2 text-sm text-gray-600">Calculando detalles...</span>
            </div>
            
            <!-- Detalles del préstamo -->
            <div *ngIf="loanDetails && !loadingLoanDetails" class="space-y-3">
              <!-- Monto de pago -->
              <div class="flex items-center justify-between">
                <div class="flex items-center space-x-2">
                  <div class="w-6 h-6 bg-gray-300 rounded-full flex items-center justify-center">
                    <span class="text-xs font-bold text-gray-600">$</span>
                  </div>
                  <span class="text-sm text-gray-700">Monto de pago</span>
                </div>
                <span class="text-sm font-semibold text-gray-900">{{ formatCurrency(loanDetails.paymentAmount) }}</span>
              </div>
  
              <!-- Plazos semanales -->
              <div class="flex items-center justify-between">
                <div class="flex items-center space-x-2">
                  <div class="w-6 h-6 bg-gray-300 rounded-full flex items-center justify-center">
                    <span class="text-xs font-bold text-gray-600">✓</span>
                  </div>
                  <span class="text-sm text-gray-700">Plazos semanales:</span>
                </div>
                <span class="text-sm font-semibold text-gray-900">{{ loanDetails.weeklyTerms }}</span>
              </div>
  
              <!-- Próxima fecha de pago -->
              <div class="flex items-center justify-between">
                <div class="flex items-center space-x-2">
                  <div class="w-6 h-6 bg-gray-300 rounded-full flex items-center justify-center">
                    <span class="text-xs font-bold text-gray-600">📅</span>
                  </div>
                  <span class="text-sm text-gray-700">Próxima fecha de pago</span>
                </div>
                <span class="text-sm font-semibold text-gray-900">{{ loanDetails.nextPaymentDate }}</span>
              </div>
  
              <!-- Total a pagar con interés -->
              <div class="flex items-center justify-between">
                <div class="flex items-center space-x-2">
                  <div class="w-6 h-6 bg-gray-300 rounded-full flex items-center justify-center">
                    <span class="text-xs font-bold text-gray-600">%</span>
                  </div>
                  <span class="text-sm text-gray-700">Total a pagar con interés*:</span>
                </div>
                <span class="text-sm font-semibold text-gray-900">{{ formatCurrency(loanDetails.totalWithInterest) }}</span>
              </div>
            </div>
  
            <!-- Nota al pie -->
            <div *ngIf="loanDetails && !loadingLoanDetails" class="mt-4 pt-3 border-t border-gray-200">
              <p class="text-xs text-gray-500">
                *Esta tabla es solamente una estimación y los montos finales pueden variar dependiendo de tu evaluación
              </p>
            </div>
          </div>
        </div>

        <!-- Botón -->
        <button
          type="submit"
          class="btn-primary w-full max-w-[300px] h-[46px] mt-6 mx-auto"
          [disabled]="registrationForm.invalid"
          [class.opacity-50]="registrationForm.invalid"
        >
          Registrarme
        </button>
      </form>
    </div>
  </div>
</div>

<!-- Componente de Loading -->
<app-loading
  [show]="(formState$ | async)?.isLoading || false"
  message="Registrando usuario..."
>
</app-loading>


<app-general-modal
  [(visible)]="showCancelModal"
  [showFooter]="false"
  [closable]="false"
  contentClass="flex flex-col items-center text-center p-8"
  [modalStyle]="{width: '90vw', maxWidth: '420px'}"
  (modalHide)="onCancelModal()">
  
  <!-- Contenido del modal -->
  <h2 class="text-xl font-bold text-gray-900 mb-3">
    Cancelar solicitud
  </h2>
  
  <p class="text-base text-gray-600 mb-8 leading-relaxed max-w-sm">
    ¿Estás seguro de que deseas salir del flujo? Cuando regreses puedes retomarlo.
  </p>
  
  <div class="flex flex-col w-full space-y-3 max-w-xs">
    <button 
      type="button"
      class="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-3.5 px-6 rounded-xl transition-all duration-200 transform hover:scale-105 shadow-lg"
      (click)="onConfirmCancel()">
      Sí, salir del flujo
    </button>
    
    <button 
      type="button"
      class="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold py-3.5 px-6 rounded-xl border border-gray-300 transition-all duration-200 transform hover:scale-105"
      (click)="onCancelModal()">
      Continuar aquí
    </button>
  </div>
</app-general-modal>


<app-general-modal
  [(visible)]="showRequestNumberModal"
  [showFooter]="false"
  [closable]="false"
  [modalStyle]="{ width: '90vw', maxWidth: '420px' }"
  contentClass="flex flex-col gap-5 items-center text-center p-6 sm:p-8"
  (modalHide)="onCloseRequestNumberModal()">

  <!-- Título -->
  <h2 class="text-2xl font-extrabold text-gray-900">
    Número de solicitud
  </h2>

  <!-- Descripción -->
  <p class="text-base text-gray-700 leading-relaxed max-w-sm">
    Tu número de solicitud es importante durante el proceso de registro de tu información.
  </p>

  <!-- Caja con el folio y botón copiar -->
  <div class="w-full max-w-xs sm:max-w-sm">
    <div class="flex items-center justify-between bg-lime-300 rounded-xl px-4 py-4 shadow-inner">
      <span class="text-xl font-bold text-gray-900 select-all">{{ requestNumber }}</span>

      <!-- Botón copiar -->
      <button type="button"
              class="p-2 rounded-lg bg-indigo-50 hover:bg-indigo-100 active:scale-95 transition"
              aria-label="Copiar número de solicitud"
              (click)="copyRequestNumber()">
        <!-- Usa el ícono que prefieras: PrimeIcons o SVG -->
        <!-- <i class="pi pi-copy text-indigo-900 text-lg"></i> -->
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-indigo-900"
             fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
        </svg>
      </button>
    </div>

    <!-- Nota inferior -->
    <div class="mt-3 text-[11px] tracking-wide text-gray-600 uppercase">
      Te recomendamos que lo copies y guardes
    </div>
  </div>

  <!-- Botón Aceptar -->
  <div class="w-full max-w-sm mt-2">
    <button type="button"
            class="w-full bg-indigo-500 hover:bg-indigo-600 text-white font-semibold py-3.5 rounded-xl transition-all duration-200 shadow-lg active:scale-95"
            (click)="onAcceptRequestNumber()">
      Aceptar
    </button>
  </div>
</app-general-modal>
